/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Integration_TitleInputs */

const en_svc_ai_integration_title = /** @type {(inputs: Svc_Ai_Integration_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Integration`)
};

const ar_svc_ai_integration_title = /** @type {(inputs: Svc_Ai_Integration_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تكامل الذكاء الاصطناعي`)
};

const bn_svc_ai_integration_title = /** @type {(inputs: Svc_Ai_Integration_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI ইন্টিগ্রেশন`)
};

const de_svc_ai_integration_title = /** @type {(inputs: Svc_Ai_Integration_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-Integration`)
};

const es_svc_ai_integration_title = /** @type {(inputs: Svc_Ai_Integration_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integración de IA`)
};

const fr_svc_ai_integration_title = /** @type {(inputs: Svc_Ai_Integration_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intégration de l'IA`)
};

const pt_svc_ai_integration_title = /** @type {(inputs: Svc_Ai_Integration_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integração de IA`)
};

const zh_svc_ai_integration_title = /** @type {(inputs: Svc_Ai_Integration_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`人工智能集成`)
};

const tr_svc_ai_integration_title = /** @type {(inputs: Svc_Ai_Integration_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yapay Zeka Entegrasyonu`)
};

const ru_svc_ai_integration_title = /** @type {(inputs: Svc_Ai_Integration_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Интеграция ИИ`)
};

const pl_svc_ai_integration_title = /** @type {(inputs: Svc_Ai_Integration_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integracja AI`)
};

/**
* | output |
* | --- |
* | "AI Integration" |
*
* @param {Svc_Ai_Integration_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_integration_title = /** @type {((inputs?: Svc_Ai_Integration_TitleInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Integration_TitleInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_integration_title(inputs)
	if (locale === "bn") return bn_svc_ai_integration_title(inputs)
	if (locale === "de") return de_svc_ai_integration_title(inputs)
	if (locale === "es") return es_svc_ai_integration_title(inputs)
	if (locale === "fr") return fr_svc_ai_integration_title(inputs)
	if (locale === "pt") return pt_svc_ai_integration_title(inputs)
	if (locale === "zh") return zh_svc_ai_integration_title(inputs)
	if (locale === "tr") return tr_svc_ai_integration_title(inputs)
	if (locale === "ru") return ru_svc_ai_integration_title(inputs)
	if (locale === "pl") return pl_svc_ai_integration_title(inputs)
	return en_svc_ai_integration_title(inputs)
});
export { svc_ai_integration_title as "svc_ai-integration_title" }